import { getAllSubcategoriesProduct } from './getAllSubcategoriesProduct'

export const subcategoriesProduct = [getAllSubcategoriesProduct]
